export default "__VITE_ASSET__D3SWp57u__"